// Cache service for localstorage
import Globals from "@/components/globals";

const cache = {
    get(key) {
        const value = window.localStorage.getItem(key);
        if (!value) {
            console.warn(`Value of ${key} is undefined`);
            return false;
        }
        try {
            return JSON.parse(value);
        } catch (e) {
            return value;
        }
    },
    set(key, value) {
        if (value && typeof value == "object") {
            return window.localStorage.setItem(key, JSON.stringify(value));
        } else {
            return window.localStorage.setItem(key, value);
        }
    },
    remove(key) {
        if (window.localStorage.getItem(key) !== null) {
            window.localStorage.removeItem(key);
        }
    },
    /*
    //  @deprecated, use cacheService.get() instead
        Ces deux fonctions getCacheObject et addCacheObject proviennent d'un ancien services, elles ont été
        copié telles quelle. elles font la même chose que dans le "if (value && typeof value == "object")" des
        fonction get et set
     */
    getCacheObject(key) {
        const res = window.localStorage.getItem(key);
        return res && res !== "undefined" ? JSON.parse(res) : null;
    },
    //  @deprecated, use cacheService.set() instead
    addCacheObject(key, value) {
        this.set(key, JSON.stringify(value));
    },

    getRem3rchUser() {
        const value = window.localStorage.getItem("Rem3rch_user");
        if (!value) {
            console.warn("probleme avec rem3rch_user 1");
            return false;
        }
        try {
            return JSON.parse(value);
        } catch (e) {
            console.warn("probleme avec rem3rch_user 2");
            return false;
        }
    },
    getBrands() {
        return this.getRem3rchUser().user.brands;
    },
    setBrands(brands) {
        let rem3rchUser = this.getRem3rchUser();
        rem3rchUser.user.brands = brands;
        this.set("Rem3rch_user", rem3rchUser);
    },

    setRem3rchUserAndToken(rem3rchUserAndToken) {
        if (!rem3rchUserAndToken.hasOwnProperty("user")) {
            throw "No rem3rch user object given";
        }
        if (!rem3rchUserAndToken.hasOwnProperty("token")) {
            throw "No rem3rch token given";
        }
        this.set("Rem3rch_user", { user: rem3rchUserAndToken.user, token: rem3rchUserAndToken.token });
    },

    setRem3rchUserRoles(roles) {
        let rem3rchUser = this.getRem3rchUser();
        rem3rchUser.user.roles = roles;
        this.set("Rem3rch_user", rem3rchUser);
    },
    setRem3rchUserProfiles(profiles) {
        let rem3rchUser = this.getRem3rchUser();
        rem3rchUser.user.profiles = profiles;
        this.set("Rem3rch_user", rem3rchUser);
    },
    setFilterStatusForecast(filterStatusForecast) {
        return this.set("filterStatusForecast", filterStatusForecast);
    },

    getCurrentBrandId() {
        return this.get("currentBrandId");
    },
    getCurrentBrandName() {
        return privateMethods.privateCurrentBrand().name || null;
    },
    getCurrentBrandImg() {
        const value = privateMethods.privateCurrentBrand();
        let url = Globals.getBaseUrl() + value.imgPath + value.logo;
        return url || null;
    },
    getBrandColors() {
        const currentBrand = privateMethods.privateCurrentBrand();
        return {
            color1: currentBrand.backgroundColor,
            color2: currentBrand.linksColor,
            color3: currentBrand.thirdColor,
            color4: currentBrand.fourthColor
        };
    },
    getLinkColor() {
        return this.getBrandColors().color2 || null;
    },

    getCurrentCampaignName() {
        const currentCampaign = privateMethods.privateCurrentCampaign();
        return (currentCampaign && currentCampaign.name) || null;
    },

    getCurrentCampaignId() {
        return this.get("currentCampaignId");
    },

    getCurrentCampaignShort() {
        return privateMethods.privateCurrentCampaign().shortName;
    },

    getCurrentStandId() {
        return this.get("currentStandId");
    },
    getCurrentStandName() {
        return privateMethods.privateCurrentStand().name;
    },

    getUserLang() {
        let value = privateMethods.privateCurrentUserLang();
        value = (value && value.code) || "en";
        return value;
    },
    getUserLangId() {
        return this.get("userLangId");
    },

    getCurrentZoneName() {
        return privateMethods.privateCurrentZone().name || null;
    },
    getCurrentZoneNameShort() {
        return privateMethods.privateCurrentZone().abbreviation || null;
    },
    getCurrentZoneId() {
        return this.get("currentZoneId");
    },
    getFilterStatusForecast() {
        return this.get("filterStatusForecast");
    },

    getUserRoles() {
        const currentUser = this.getRem3rchUser().user;
        return currentUser.roles;
    },
    getUserProfiles() {
        const currentUser = this.getRem3rchUser().user;
        return currentUser.profiles;
    },
    /**
     * removes everything inside localeStorage but a few select
     * keys such as the user preferences on the plano menus.
     */
    clearLocalStorage() {
        const showToolbar = this.get("showToolbar");
        const showLibrary = this.get("showLibrary");
        const showNewbieTool = this.get("showNewbieTool");
        const rechallengesMessagesRead = this.get("rechallengesMessageRead");

        localStorage.clear();

        this.set("showToolbar", showToolbar);
        this.set("showLibrary", showLibrary);
        this.set("showNewbieTool", showNewbieTool);
        this.set("rechallengesMessageRead", rechallengesMessagesRead);
    },
    /**
     * Clears certain data when a page is reloaded. This can also be the case when the zone/brand is changed.
     */
    clearOnReload() {
        this.remove("functionalities");
        this.remove("access_brand");
        this.remove("all_access");
        this.remove("all_applications");
        // prepare resetting the user's roles by removing them here. The actual re-assignment is done where the clearOnReload() method is called
        this.setRem3rchUserRoles(null);
        this.setRem3rchUserProfiles(null);
    }
};
export default cache;

const privateMethods = {
    privateCurrentBrand() {
        let currentBrandId = cache.getCurrentBrandId();
        let user = cache.getRem3rchUser().user;
        let currentBrand = user.brands.find(brand => brand.id == currentBrandId);
        return currentBrand;
    },

    privateCurrentStand() {
        let currentStandId = cache.getCurrentStandId();
        let currentBrand = this.privateCurrentBrand();
        let currentStand = currentBrand.stands.find(stand => stand.id == currentStandId);
        return currentStand;
    },
    privateCurrentCampaign() {
        let currentCampaignId = cache.getCurrentCampaignId();
        let currentBrand = this.privateCurrentBrand();
        let currentCampaign = currentBrand.campaigns.find(campaign => campaign.id == currentCampaignId);
        return currentCampaign;
    },
    privateCurrentUserLang() {
        let currentLanguageId = cache.getUserLangId();
        let user = cache.getRem3rchUser().user;
        let currentLang = (user && user.languages.find(lang => lang.id == currentLanguageId)) || null;
        return currentLang;
    },
    privateCurrentZone() {
        let currentZoneId = cache.getCurrentZoneId();
        let currentBrand = this.privateCurrentBrand();
        let currentZone = currentBrand.zones.find(lang => lang.id == currentZoneId);
        return currentZone;
    }
};



// WEBPACK FOOTER //
// ./src/services/cache.js